<div class="div_loading">
    <div class="my-container" [hidden]="!loading">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
</div>

<div mat-dialog-title class="matDialogTitle" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
    <span>
        <span>{{ title }}</span>
    </span>
    <span (click)="close()">
        <mat-icon class="close">close</mat-icon>
    </span>
</div>


<div class="matDialogContent" mat-dialog-content style="overflow-y: hidden !important;">
    <form [formGroup]="form1_group">
        <div class="row" style="direction: rtl;">

            <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-2">
                <div class="pager_checkbox">
                    <div class="material-icons pager_icons cursor" (click)="check_access(3,0,selected_record,1,1)">
                        delete
                    </div>
                    <div style="display: inline-block;">
                        <mat-checkbox (change)="get_select($event.checked)" [(indeterminate)]="indeterminate">
                        </mat-checkbox>
                    </div>
                </div>
            </div>

            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6  div_panding" style="float: right;">
                <input style="margin:0px 1px;width:49%" class="wh-input" name="than" formControlName="than"
                    autocomplete="off" [required]="true" pattern="[0-9]{1,}" placeholder="شماره چک از">

                <input style="width:50%" class="wh-input" name="until" formControlName="until" autocomplete="off"
                    placeholder="شماره چک تا" pattern="[0-9]{1,}">
            </div>

            <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"
                style="text-align: right;margin-top:5px;padding:0px">
                <button type="button" (click)="insert()" [disabled]="!form1_group.valid" style="margin-left:1px">درج
                    جدید</button>
                <button type="button" (click)="load_data()">مرتب کردن</button>
            </div>

        </div>
    </form>

    <div class="row">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12" style="padding:0px">
            <div class="content-body2 control-content-body" [ngClass]="{content_body_en:lang==2}"
                style='overflow-x:auto;direction:rtl;' (window:resize)="change_resize()">
                <mat-table [dataSource]="dataSource" style='min-width:100%'
                    class='table-scroll mat_table_fa_without_scroll pe1'
                    [ngClass]="{mat_table_en_without_scroll:lang==2,en1:lang == 2}"
                    [ngStyle]="{'direction' : lang == 2 ? 'ltr' : 'rtl'}">
                    <ng-container matColumnDef="row">
                        <mat-header-cell *matHeaderCellDef style='max-width:40px'>
                            <span *ngIf="lang == 1">ردیف</span>
                            <span *ngIf="lang == 2">#</span>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let x;let i = index" style='max-width:40px'>{{ i + 1 }}
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="title">
                        <mat-header-cell *matHeaderCellDef>
                            <span *ngIf="lang == 1">شماره چک</span>
                            <span *ngIf="lang == 2">Title</span>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let x;let i = index" style="padding:0px !important">
                            <input class="wh-input" [value]="x.cheque_numbers_title"
                                (change)="update($event,x.cheque_numbers_id)"
                                [ngClass]="{mat_table_selected2:x.checked == true}"
                                style="direction: rtl;margin:0px;text-align:center">
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="status">
                        <mat-header-cell *matHeaderCellDef>
                            <span *ngIf="lang == 1">وضعیت چک</span>
                            <span *ngIf="lang == 2">Title</span>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let x;let i = index">
                            {{ x.site_cheque_status_title }}
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="operation">
                        <mat-header-cell *matHeaderCellDef style='max-width:70px'>
                            <span *ngIf="lang == 1"> عملیات </span>
                            <span *ngIf="lang == 2">Operation</span>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let x;let i = index" style='max-width:70px'>
                            <mat-checkbox (change)="get_select_records(i)" name="selete_records[]"
                                [value]="x.cheque_numbers_id" [checked]="x.checked"></mat-checkbox>
                            <span (click)="check_access(3,0,x.cheque_numbers_id,0,1)"><i class="far fa-trash-alt icon"
                                    style='margin:0px 4px;'></i></span>
                        </mat-cell>
                    </ng-container>

                    <mat-header-row *matHeaderRowDef="displayedColumns" color="primary"></mat-header-row>
                    <mat-row *matRowDef="let row;columns:displayedColumns;let i = index"
                        (click)="mat_table_selectedRow = row" (mouseenter)="mat_table_hoverRow = row"
                        [ngClass]="{'mat_table_selected': row === mat_table_selectedRow,mat_table_selected2:row.checked == true,'mat_table_hover': row === mat_table_hoverRow}"
                        class="cursor"></mat-row>

                </mat-table>


            </div>
        </div>

    </div>
</div>